import { isEmpty } from "lodash";
import { connect } from "react-redux";
import { compose, lifecycle } from "recompose";

import { BANNERS_TYPES } from "@dpdgroupuk/mydpd-enums";

import { AddressModels, ShipmentModels } from "~/models";
import { ShipmentActions } from "~/pages/Shipment/redux";

export default compose(
  connect(null, (dispatch, { pageConfig }) => ({
    clearContactDetails: () =>
      dispatch(ShipmentActions.clearContactDetails(pageConfig.formName)),
    clearPage: () => dispatch(ShipmentActions.unmountShipmentPage()),
  })),
  lifecycle({
    componentDidUpdate(prevProps) {
      const { dispatch, pageConfig, selectedCountry } = this.props;
      // POTENTIALLY CAN BE MOVED TO ADDRESS BOOK SELECTION LOGIC
      if (
        ShipmentModels.isSwapItShipmentType(
          prevProps.createShipmentValues?.shipmentType
        ) &&
        !AddressModels.isCountryDomestic(selectedCountry?.countryKey) &&
        !isEmpty(this.props.createShipmentValues?.inboundConsignment)
      ) {
        dispatch(ShipmentActions.resetInboundConsignment(pageConfig.formName));
      }
    },
    componentWillUnmount() {
      const {
        clearPage,
        banner,
        consignmentBannerId,
        setConsignmentBannerId,
        abortController,
      } = this.props;

      clearPage();
      banner.hideByType(BANNERS_TYPES.WARNING);
      banner.hideByType(BANNERS_TYPES.ALERT);
      banner.hideByType(BANNERS_TYPES.SUCCESS);

      if (consignmentBannerId) {
        banner.hideById(this.props.consignmentBannerId);
        setConsignmentBannerId();
      }

      abortController.abort();
    },
  })
);
